import React from 'react';

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Typography,
  DialogActions,
} from '@mui/material';

import type { NotificationViewProperties } from './NotificationView.types';

export const NotificationView: React.FC<NotificationViewProperties> = ({
  show,
}) => {
  return (
    <Dialog open={show}>
      <DialogTitle>Вы не в сети!</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Пожалуйста,
          <Typography variant='body1' component='span' sx={{
            ml: 0.5
          }}>
            не обновляйте страницу
          </Typography>
          !
        </DialogContentText>
        <DialogContentText>
          Вы можете потерять все несохраненные данные. Мы уведомим вас, когда
          соединение будет восстановлено.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button>Проверить связь</Button>
      </DialogActions>
    </Dialog>
  );
};
